/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */


/**
 * Open cart drawer on page load
 */
;(function(){
  if ( location.search == '?drawer=true' ) {
    var cartDrawerTrigger = document.querySelector('[data-action="open-drawer"][data-drawer-id="sidebar-cart"]');
    console.log({cartDrawerTrigger});
    cartDrawerTrigger.click();
  }
})();

/**
 * Adds a product selector in the cart drawer if the parameters is reached.
 * Products added from this will be free due to a Shopify+ Script
 * Settings from /sections/cart-drawer.liquid
 */
;(function() {
  // fetch cart
  var fetchCart = function(callback) {
    fetch('/cart.js', { method: 'GET' })
    .then(function(response) {
      return response.json()
    })
    .then(function(cart) {
      console.log(cart);
      callback(cart);
    })
    .catch(function(error) {
      console.error('Error:', error);
    });
  }

  // select added free-items from cart
  var getFreeItemsFromCart = function(callback) {
    fetchCart(function(cart) {
      var freeItemsInCart = [];  
      
      for (var i = 0; i < cart.items.length; i++) {
        var cartItem = cart.items[i];
        
        if ( cartItem.properties._is_free === true ) {
          freeItemsInCart.push(cartItem);
        }
      }

      callback(freeItemsInCart, cart.items);
    });
  }

  // attach click listener and logic to free-item variants
  var attachEventListeners = function(productNode, container) {
    var options = Array.from(productNode.querySelectorAll('[data-variant-id]'));

    if ( options.length ) {
      for (var i = 0; i < options.length; i++) {
        var option = options[i]; 

        option.addEventListener('click', function(e) {
          var variantId = this.dataset.variantId;
          
          var formData = {
            'items': [{
              'id': variantId,
              'quantity': 1,
              'properties': { '_is_free': true }
            }]
          };

          container.classList.add('processing');
          
          console.log('adding free items to cart', formData);

          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
          })
          .then(function(response) {
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

            setTimeout(() => {
              container.classList.remove('processing');
            }, 500);

            return response.json();
          })
          .catch(function(error) {
            console.error('Error:', error);
          });
        });
      }
    }
  };

  // build free item selector
  var buildFreeItems = function(products, container) {
    for (var i = 0; i < products.length; i++) {
      var product = products[i];
      var element = document.createElement('div');
      element.classList.add('free-product');
      element.innerHTML = product.html;

      container.appendChild(element);
      attachEventListeners(element, container);
    }

    console.log('built items in', container);
  };

  // remove free items from cart
  var removeAddedFreeItems = function() {
    getFreeItemsFromCart(function(freeItemsInCart) {
      var formData = { 'updates': {} };
      var hasFreeItemsInCart = false;
  
      for (var i = 0; i < freeItemsInCart.length; i++) {
        var freeItem = freeItemsInCart[i];
        formData.updates[freeItem.id] = 0;
        hasFreeItemsInCart = true;
      }
  
      if ( hasFreeItemsInCart ) {
        console.log('deleting free items from cart', freeItemsInCart);
  
        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then(function(response) {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          return response.json();
        })
        .catch(function(error) {
          console.error('Error:', error);
        });
      }
    })
  };

  // main logic and variables
  var toggleFreeItemsSelector = function(msg) {
    var enableCartTotalFreeItemLogic = window.theme?.cart?.enable_cart_total_free_item_logic ?? false;
    var freeItemLimit = Number(window.theme?.cart?.free_item_limit) ?? 100000;
    var enableActivatorsFreeItemLogic = window.theme?.cart?.enable_activators_free_item_logic ?? false;
    var activatorProducts = window.theme?.cart?.activator_products ?? [];
    var amountOfActivatorsNeeded = window.theme?.cart?.amount_of_activators_needed ?? 10;
    var freeProducts = window.theme?.cart?.free_products ?? [];
    var cartTotal = Number(window.theme.cartTotal);
    var freeItemsWrapper = document.querySelector('[data-free-items]');

    // fetches cart and starts logic
    getFreeItemsFromCart(function(freeItemsInCart, allCartItems) {
      
      // counts amount of activator products in cart currently
      var activatorsInCart = function() {
        var activatorsInCart = 0;
        
        for (var i = 0; i < allCartItems.length; i++) {
          var cartItem = allCartItems[i];
          
          if ( activatorProducts.includes(cartItem.handle) ) {
            activatorsInCart += cartItem.quantity;
          }
        }

        return activatorsInCart;
      }

      // conditionals for showing free item selector based on "cart total"-logic
      var cartTotalConditional = function() {
        if ( freeItemsInCart.length ) return false;
        if ( !enableCartTotalFreeItemLogic ) return false;
        if ( cartTotal < freeItemLimit ) return false;

        return true;
      };

      // conditionals for showing free item selector based on "activator"-logic
      var cartActivatorsConditional = function() {
        if ( freeItemsInCart.length ) return false;
        if ( !enableActivatorsFreeItemLogic ) return false;
        if ( !activatorProducts.length ) return false;

        if ( activatorsInCart() < amountOfActivatorsNeeded ) return false;

        return true;
      };
      
      if ( freeItemsWrapper ) {
        var freeItemsContainer = freeItemsWrapper.querySelector('[data-free-items-container]');

        // check if either of the free-item logics passes
        if ( cartTotalConditional() || cartActivatorsConditional() ) {
          // show free item selector
          freeItemsWrapper.style.display = 'block';
          buildFreeItems(freeProducts, freeItemsContainer);
        } else {
          // hide free item selector
          freeItemsContainer.innerHTML == '';
          freeItemsWrapper.style.display = 'none';

          // remove free items from cart if nothing matches anymore
          if ( enableActivatorsFreeItemLogic && enableCartTotalFreeItemLogic ) {
            if ( cartTotal < freeItemLimit && activatorsInCart() < amountOfActivatorsNeeded ) {
              removeAddedFreeItems()
            }
          } else if ( enableActivatorsFreeItemLogic ) {
            if ( activatorsInCart() < amountOfActivatorsNeeded ) {
              removeAddedFreeItems()
            }
          } else if ( enableCartTotalFreeItemLogic ) {
            if ( cartTotal < freeItemLimit ) {
              removeAddedFreeItems();
            }
          }
        }
      }
    });
  };
  
  document.addEventListener('cart:rerendered', function() {
    toggleFreeItemsSelector('cart:rerendered');
  });
})();

(function() {
	var touchingCarousel = false,
		touchStartCoords;

	document.body.addEventListener('touchstart', function(e) {
		if (e.target.closest('.flickity-slider'))
		{
			touchingCarousel = true;
		} else
		{
			touchingCarousel = false;
			return;
		}

		touchStartCoords = {
			x: e.touches[0].pageX,
			y: e.touches[0].pageY,
		};
	});

	document.body.addEventListener(
		'touchmove',
		function(e) {
			if (!(touchingCarousel && e.cancelable))
			{
				return;
			}

			var moveVector = {
				x: e.touches[0].pageX - touchStartCoords.x,
				y: e.touches[0].pageY - touchStartCoords.y,
			};

			if (Math.abs(moveVector.x) > 7) e.preventDefault();
		},
		{
			passive: false,
		}
	);
})();

jQuery(document).ready(function() {
	/*jQuery('div.ProductForm__Variants > div:nth-child(2) > ul').addClass('coloroptions');
		jQuery( ".coloroptions li label" ).each(function( index ) {
		  var procol  = jQuery( this ).text();
		  jQuery(this).css('background','#'+procol);
		}); SizeSwatchList*/
	jQuery('.SizeSwatchList li label').each(function() {
		var p_variant = jQuery(this).text();
    
    if (!product_variants_removed) {
      var product_variants_removed = [];
    }

		if (product_variants_removed.indexOf(p_variant) != -1) {
			jQuery(this).addClass('OutOfStock');
		}
	});
});

document.addEventListener('product:changed', function() {
	alert('p changed')
})


/**
 *
 * Free shipping load bar
 *
 */
if (!window.theme.cartTotal || !window.theme.freeShippingTreshold)
{
	window.theme.cartTotal = document.querySelector('.Cart__ShippingNotice[data-price]') ? document.querySelector('.Cart__ShippingNotice[data-price]')?.dataset?.price : 0;
	window.theme.freeShippingTreshold = document.querySelector('.remaining_amount_bar')?.dataset.freeShippingTreshold;
}


function calcProgressInPercent(price, treshold) {
	const progress = Math.abs((price * 100) / treshold);
	const progressInPercentMax = progress > 100 ? 100 : progress;

	return progressInPercentMax + '%';
}

function setFreeShippingBarProgress(update = false) {
	const remainingAmountBar = document.querySelector('.remaining_amount_bar');
	if (remainingAmountBar) {
		

		let oldCartTotal = window.theme.cartTotal;
		let oldFreeShippingTreshold = window.theme.freeShippingTreshold;

		if (update)
		{
			window.theme.cartTotal = document.querySelector('.Cart__ShippingNotice[data-price]') ? document.querySelector('.Cart__ShippingNotice[data-price]')?.dataset?.price : 0;
			window.theme.freeShippingTreshold = document.querySelector('.remaining_amount_bar')?.dataset.freeShippingTreshold;
		}
		const cartTotal = window.theme.cartTotal;
		const freeShippingTreshold = window.theme.freeShippingTreshold;

		const oldProgress = calcProgressInPercent(oldCartTotal, oldFreeShippingTreshold);
		const newProgress = calcProgressInPercent(cartTotal, freeShippingTreshold);

		remainingAmountBar.style.width = oldProgress;

		setTimeout(() => {
			remainingAmountBar.classList.add('animate');
			remainingAmountBar.style.width = newProgress;
		}, 1);
	}
}

setFreeShippingBarProgress(true);





/**
 *
 * Video controls
 *
 *
 */

function videoControles(videoElem) {
	playPause(videoElem);

	if (!videoElem.classList.contains('no-audio'))
	{
		const volumeControl = videoElem.parentElement.querySelector(
			'.js-volume'
		);
		volumeControl.classList.remove('hidden');

		videoSoundController(videoElem);
	}
}

function videoSoundController(videoElem) {
	/* Mute/ unmute selfhosted video */
	const volumeControl = videoElem.parentElement.querySelector('.js-volume');

	if (volumeControl)
	{
		volumeControl.addEventListener('click', function() {
			if (videoElem.muted === true)
			{
				unmute(volumeControl, videoElem);
			} else
			{
				mute(volumeControl, videoElem);
			}
		});
	}
}

// function hasAudio(videoElem) {
//   return (
//     videoElem.mozHasAudio ||
//     Boolean(videoElem.webkitAudioDecodedByteCount) ||
//     Boolean(videoElem.audioTracks && videoElem.audioTracks.length)
//   );
// }

function unmute(volumeControl, videoElem) {
	videoElem.muted = false;
	videoElem.volume = 1;
	videoElem.classList.remove('muted');
	volumeControl.classList.remove('muted');
}

function mute(volumeControl, videoElem) {
	videoElem.muted = true;
	videoElem.volume = 0;
	videoElem.classList.add('muted');
	volumeControl.classList.add('muted');
}

function playPause(videoElem) {
	const videoWrap = videoElem.parentElement;

	videoElem.addEventListener('click', function() {
		if (videoElem.paused)
		{
			videoElem.play();
		} else
		{
			videoElem.pause();
		}
	});

	//Add or remove class if paused
	videoElem.onpause = (event) => {
		videoWrap.classList.add('paused');
	};
	videoElem.onplay = (event) => {
		videoWrap.classList.remove('paused');



		// if (!videoWrap.classList.contains('hasStarted')) {
		//   videoWrap.classList.add('hasStarted');
		//   setTimeout(() => {
		//     if (hasAudio(videoElem)) {
		//       const volumeControl = videoElem.parentElement.querySelector(
		//         '.js-volume'
		//       );
		//       volumeControl.classList.remove('hidden');
		//     }
		//   }, 50);
		// }
	};
}

/**
 *
 * MutationObserver callback
 *
 */
function callback(mutationsList, observer) {
	console.log('Mutations:', mutationsList);
	console.log('Observer:', observer);
	mutationsList.forEach((mutation) => {
		if (mutation.attributeName === 'class')
		{
			const classList = mutation.target.classList;
			const volumeControl = mutation.target.querySelector('.js-volume');
			const mutationVideoElem = mutation.target.querySelector('video');

			setTimeout(() => {
				if (classList.contains('is-selected'))
				{
					console.log('play is selected');
					mutationVideoElem.play();
					return;
				} else
				{
					mute(volumeControl, mutationVideoElem);
					mutationVideoElem.pause();
					return;
				}
			}, 20);
		}
	});
}

/**
 *
 *  Mute slide vidio if not selected
 *
 */
const inlineVideoSlides = document.querySelectorAll(
	'.Product__SlideItem--inline-video'
);

if (inlineVideoSlides)
{
	//MutationObserver
	const mutationObserver = new MutationObserver(callback);

	//Loop inline videos
	inlineVideoSlides.forEach((inlineVideoSlide) => {
		mutationObserver.observe(inlineVideoSlide, {
			attributes: true,
		});

		/**
		 * @type {HTMLVideoElement}"
		 */
		const videoElem = inlineVideoSlide.querySelector('video');
		videoControles(videoElem);
	});
}

(function() {
	$('body').on('submit', 'form[action="/cart"]', function () {
		var modal = $(this).find('.Cart__TermsModal');
		var accept = $(this).find('.js-accept');
		var deny = $(this).find('.js-deny');
		var checkbox = $(this).find('#agree');

		if (checkbox && checkbox.is(':checked') === false) {
			modal.css({
				transform: '',
				transition: '',
			}).slideToggle();

			var y = 0;
			var translate = 0;

			modal.on('touchstart', function (event) {
				var touch = event.touches[0];

				y = touch.pageY;

        modal.css({
          transition: '',
        });
			});

			modal.on('touchmove', function (event) {
				var touch = event.touches[0];

				translate = Math.round(touch.pageY - y);

				if (translate < 0) {
					translate = 0;
				}

				modal.css('transform', 'translateY(' + translate.toString() + 'px)');
			});

			modal.on('touchend', function () {
			  if (translate >= modal.outerHeight() / 2) {
					modal.css({
						transform: 'translateY(100%)',
						transition: '250ms',
					});

					setTimeout(function () {
						modal.css('display', 'none');
					}, 250);
        } else {
			    modal.css({
            transform: '',
            transition: '250ms',
          });
        }
			});

			accept.on('click', function (event) {
				if (checkbox.is(':checked') === false) {
					event.preventDefault();

					checkbox.prop('checked', true);

					modal.css({
						transform: '',
						transition: '250ms',
					});

					$(this).click();
				}
			});

			deny.on('click', function (event) {
				event.preventDefault();

				modal.css({
					transform: 'translateY(100%)',
					transition: '250ms',
				});

				setTimeout(function () {
					modal.css('display', 'none');
				}, 250);
			});

			return false;
		}

		return true;
	});
})();



/***
 * 
 * Logo slider
 * 
 */


// const logoSliders = document.querySelectorAll('.logo-slider');

// logoSliders.forEach(logoSlider => {
// if (logoSlider.querySelector('[data-flickity-config]')) {
	
// 	const sls = theme.functions.carousel(logoSlider.querySelector('[data-flickity-config]'));
// }
// });